import React from "react"
import LinuxHostingBlock from "../hosting/HostingBlock"

const HostingBlock = () => {
  return (
      <section className="pricing text-start bg-white">
        <div className="container-xl">
          <h3 className="mb-4 component-title text-dark-blue">
            Welcome to Motherhost - Your Trusted Partner in Web Hosting!
          </h3>
          <div className="row">
            <LinuxHostingBlock pid={1} gid={2}/>
            <div className="col-12 col-lg-8">
              <div className="description">
                <p>
                  <strong>Shared Hosting: </strong>Ideal for small to
                  medium-sized websites, our shared hosting plans provide
                  cost-effective solutions without compromising on performance.
                  Benefit from ample resources, easy-to-use control panels, and
                  24/7 support.
                </p>
                <p>
                  Experience the difference with Motherhost and take your online
                  presence to new heights. Sign up today and join thousands of
                  satisfied customers who trust us for their web hosting needs!
                </p>
                <p>
                  <strong>Money-back Guarantee: </strong> We stand behind our
                  service with a 30-day money-back guarantee. If you're not
                  completely satisfied, simply initiate a refund request within
                  the first 30 days from the date of purchase, and we'll
                  promptly refund your money.
                </p>

                <p>
                  While it's not obligatory to provide a reason for your refund,
                  your feedback is valuable to us. Sharing your thoughts helps
                  us better understand our customers' expectations and allows us
                  to continually enhance the quality of our services.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
  )
}

export default HostingBlock
